var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"footer-copyright"},[_vm._v("Contact evlncrnas@163.com for inquiries and feedback. Copyright @ Dezhou University Powered By "),_c('a',{attrs:{"href":"https://www.sdyunyou.cn/","target":"_blank"}},[_vm._v("YunyouNetwork")])])])
}]

export { render, staticRenderFns }